import {React, useState, useRef} from "react";
import img from "./assets/img.png";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import ConnectPopup from "../../../GlobalComponents/ConnectPopup/ConnectPopup";
const Banner = ({parentRef}) => {
  const handleDAO = () =>{
    window.location.href="/nft-auction";
  }
  const handleDapp = () =>{
    parentRef.current.firstChild.firstChild.firstChild.click();
  }
  return (
    <div className="lg:pt-[138px] py-[70px] lg:pb-[172px] bg-custom-gradient">
      <div className="container ">
        <div className="max-w-[1152px] mx-auto ">
          <div className="flex flex-col-reverse items-center lg:flex-row  gap-[70px] xl:gap-[208px]">
            <div className="xl:max-w-[553px] w-full">
              <h1 className="text-res-lg font-black mb-[19px] text-main-black">
                Revolutionizing Decentralized Finance and Empowering the
                Community
              </h1>

              <p className="text-res-ls text-main-black font-semibold mb-[20px]">
                Join the decentralized finance revolution with the R34P DAO and
                shape the future of blockchain technology.
              </p>

              <div className="flex  flex-row gap-[18px]">
                <button onClick={handleDAO} className=" w-[173px] h-10 rounded-[20px] text-res-xs  bg-main-black font-bold  ">
                  Join DAO
                </button>

                <div className="border rounded-[20px] border-solid px-[20px] pt-[10px] pb-[11px] border-main-black text-main-black w-[173px] h-[40px]">
                  <button onClick={handleDapp} id="DAO" className="text-center w-full h-full flex justify-center items-center">
                    <span className="text-res-xs font-bold">Go to DAPP</span>
                  </button>
                </div>
              </div>
            </div>
            <div className="flex-grow">
              <img src={img} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
